import { render, staticRenderFns } from "./Rappels.vue?vue&type=template&id=3c17838b&"
import script from "./Rappels.vue?vue&type=script&lang=js&"
export * from "./Rappels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports